<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="入库单号：">
					<el-input v-model="formInline.code" placeholder="请输入商品编码" clearable size="small" @change="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="商品类型：">
					<el-select v-model="formInline.typeName" placeholder="请选择商品类型" clearable size="small" @change="handleTypeNameChange">
						<el-option v-for="item in typeNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品名称：">
					<el-select v-model="formInline.productName" placeholder="请选择商品名称" clearable size="small" @change="inputChange">
						<el-option v-for="item in productNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="规格：">
					<el-input v-model="formInline.specification" placeholder="请输入规格" clearable size="small" @change="inputChange"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button v-if="btnPermission.search" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe @row-db-click="handleRowDBClick">
				<template #isConfirm>
					<el-table-column label="是否确认" min-width="120" align="center" fixed="right">
						<template #default="scope">
							<el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
							<el-tag v-else type="danger">未确认</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column label="操作" min-width="120" align="center" fixed="right">
						<template #default="scope">
							<el-button v-if="scope.row.isConfirm == false && btnPermission.confirm" icon="el-icon-finished" size="mini" type="primary" @click="handleConfirm(scope.row)">确认入库</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { GetStoreProductHistoryPageList, ConfirmStoreProduct, GetProductTypeNameList, GetProductTypeSubNameList } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import edit from "./edit.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "门店库存"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				typeName: "",
				productName: "",
				code: "",
				specification: ""
			},
			storeList: [],
			selectedStoreKeyId: "",
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "150",
					align: "center",
				},
				{
					prop: "code",
					label: "入库单号",
					isKeep: true,
					minWidth: "200",
					align: "center",
				},
				{
					prop: "productInfo.code",
					label: "商品编码",
					isKeep: true,
					minWidth: "170",
					align: "center",
				},
				{
					prop: "productInfo.typeName",
					label: "类型",
					width: "120",
					align: "center"
				},
				{
					prop: "productInfo.productName",
					label: "系列",
					width: "180",
					align: "center"
				},
				{
					prop: "productInfo.specification",
					label: "商品名称",
					width: "220",
					align: "center"
				},
				{
					prop: "price",
					label: "价格(元)",
					width: "100",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "costMoney",
					label: "成本金额(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "expense"
				},
				{
					prop: "quantity",
					label: "入库数量",
					width: "100",
					align: "center"
				},
				{
					prop: "productInfo.unit",
					label: "单位",
					width: "70",
					align: "center"
				},
				{
					prop: "typeName",
					label: "入库类型",
					width: "120",
					align: "center"
				},
				{
					prop: "content",
					label: "入库内容",
					width: "120",
					align: "center"
				},
				{
					prop: "remark",
					label: "入库备注",
					width: "120",
					align: "center"
				},
				{
					prop: "productDate",
					label: "生产日期",
					width: "120",
					align: "center"
				},
				{
					prop: "expireDate",
					label: "过期日期",
					width: "120",
					align: "center"
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					width: "120",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					width: "120",
					align: "center"
				},
				{
					prop: "confirmTime",
					label: "确认时间",
					width: "170",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "120",
					align: "center"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "120",
					align: "center"
				}
			],
			btnPermission: {
				search: true,
				confirm: true
			},
			typeNameList: [],
			productNameList: []
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();

		this.checkBtnPermission();
		this.getProductTypeNameList();
		this.getProductTypeSubNameList(this.formInline.typeName);
	},
	computed: {},
	methods: {
		// 检查按钮权限
		checkBtnPermission() {
			this.btnPermission.search = this.$checkBtnPermission("/productInput/index", "viewPage");
			this.btnPermission.confirm = this.$checkBtnPermission("/productInput/index", "confirm");
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreProductHistoryPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		handleShowHistory(row) {
			//   this.$refs.history.showHistoryDialog(row.keyId);
		},
		// 双击行事件
		handleRowDBClick(row) {
			this.$refs.edit.editShow(row);
		},
		// 确认入库
		handleConfirm(row) {
			this.$confirm("确认入库单号【" + row.code + "】入库吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					ConfirmStoreProduct({
						keyId: row.keyId
					}).then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "确认入库成功"
							});
							this.getListData();
						} else {
							this.$message({
								type: "error",
								message: res.msg
							});
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消确认入库"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 处理类型名称改变
		handleTypeNameChange(val) {
			this.formInline.productName = "";
			this.getProductTypeSubNameList(val);
			this.getListData();
		},
		// 处理商品名称改变
		handleProductNameChange(val) {
			this.formInline.productName = val;
			this.getListData();
		},
		getProductTypeNameList() {
			GetProductTypeNameList({}).then((res) => {
				if (res.code == 1) {
					this.typeNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.typeNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getProductTypeSubNameList(code) {
			var params = {
				code: code
			};
			GetProductTypeSubNameList(params).then((res) => {
				if (res.code == 1) {
					this.productNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.productNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		}
	}
};
</script>

<style scoped></style>
